import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (!data.mfa_required) setUser(data);
    return data;
  };

  const verifyMfa = async (challengeToken, code) => {
    const { data } = await api.post("/auth/mfa/verify", { challenge_token: challengeToken, code });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, verifyMfa, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
